@if (announcement$ && announcement$ | async; as announcement) {
  <p-announcement-banner
    [variant]="styleFor(announcement.level).variant"
    [icon]="styleFor(announcement.level).icon"
    [title]="announcement.title"
    [message]="announcement.message"
    [closable]="closable"
    (closed)="onBannerClosed()"
    >
    <span actions>
      <ng-content select="[actions]"></ng-content>
    </span>
  </p-announcement-banner>
}
